import { render } from "./P056.vue?vue&type=template&id=4842f479&scoped=true"
import script from "./P056.vue?vue&type=script&lang=js"
export * from "./P056.vue?vue&type=script&lang=js"

import "./P056.vue?vue&type=style&index=0&id=4842f479&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4842f479"]])

export default __exports__